<script>
import Vue from 'vue';
import VStepper from 'vuetify/es5/components/VStepper/VStepper';

export default {
    extends: VStepper,
    data() {
        return {
            step: null,
            stepsMap: {},
        };
    },
    props: {
        value: {
            default: function() {
                //hide all steps if the name is passed in the route
                return this.$route.params.stepName ? -1 : 1;
            },
        },
    },
    mounted() {
        const routeStep = this.$route.params.stepName;

        Vue.nextTick(() => {
            //index steps and step-content by their step number
            const contents = this.content;
            contents.forEach(content => {
                let stepNumber = parseFloat(content.step);
                if (!this.stepsMap[stepNumber]) {
                    this.stepsMap[stepNumber] = {};
                }
                this.stepsMap[stepNumber].content = content;

                if (content.route && routeStep == content.route) {
                    this.step = content.step;
                }

                content.$on('onNextStep', this.onNext);
                content.$on('goToStep', this.goToStep);
            });

            if (!this.step) {
                const route = Object.assign({}, this.$route);
                delete route.params.stepName;
                this.$router.replace(route);
            }

            const steps = this.steps;
            steps.forEach(step => {
                const stepNumber = parseInt(step.step);
                if (!this.stepsMap[stepNumber]) {
                    this.stepsMap[stepNumber] = {};
                }
                this.stepsMap[stepNumber].header = step;

                //assign step-content's hasErrors field to it's header, so errors are mirrored in the header.
                if (
                    this.stepsMap[stepNumber].content &&
                    typeof this.stepsMap[stepNumber].content.hasErrors != 'undefined'
                ) {
                    step.rules.push(() => !this.stepsMap[stepNumber].content.hasErrors);
                }
            });
            const nextButton = this.getChildNode(this, 'nextButton', this.$children);
            const prevButton = this.getChildNode(this, 'prevButton', this.$children);

            if (nextButton) {
                nextButton.$on('click', this.onNext);
            }
            if (prevButton) {
                prevButton.$on('click', this.onPrevious);
            }
        });
    },
    computed: {
        stepsCount() {
            return Object.values(this.stepsMap).length;
        },
    },
    methods: {
        onNext(options = {}) {
            if (this.step < this.stepsCount) {
                if (this.stepsMap[this.step] && this.stepsMap[this.step].content) {
                    if (typeof this.stepsMap[this.step].content.isValid == 'function') {
                        if (this.stepsMap[this.step].content.isValid()) {
                            this.step = Math.floor(this.step + 1);
                        }
                    } else {
                        this.step = Math.floor(this.step + 1);
                    }

                    const step = this.stepsMap[this.step];

                    const queryParams = this.$route.query;
                    this.updateRoute(step.content.route, {...options, ...queryParams});

                    window.scrollTo(0, 0);
                }
            }
        },
        onPrevious() {
            if (this.step > Object.keys(this.stepsMap)[0]) {
                this.step = Math.floor(this.step - 1);

                const step = this.stepsMap[this.step];
                this.updateRoute(step.content.route, this.$route.query);

                window.scrollTo(0, 0);
            }
        },
        goToStep(params) {
            if (params && params.route) {
                Object.keys(this.stepsMap).some(stepNumber => {
                    const step = this.stepsMap[stepNumber];
                    if (step.content && params.route === step.content.route) {
                        this.step = parseFloat(stepNumber);
                        let query = {};
                        if (params.query) {
                            query = {
                                ...this.$route.query,
                                ...params.query,
                            };
                        }

                        if (params.props) {
                            Object.keys(params.props).forEach(prop => {
                                step.content[prop] = params.props[prop];
                            });
                        }

                        this.updateRoute(step.content.route, query, params.subStepName);

                        window.scrollTo(0, 0);
                        return true;
                    }
                });
            }

            if (params && params.number) {
                if (this.stepsMap[params.number] !== undefined) {
                    this.step = params.number;
                    window.scrollTo(0, 0);
                }
            }
        },
        updateRoute(stepName, query, subStepName = null) {
            this.$router.push({
                ...this.$route,
                name: 'checkout',
                query,
                params: {
                    stepName,
                    subStepName,
                },
            });
        },
        getChildNode(context, ref, container) {
            let nextLevel = [];
            container.forEach(child => {
                if (child.$vnode.data.ref == ref) {
                    return child;
                }
                if (child.$children.length) {
                    nextLevel = nextLevel.concat(child.$children);
                }
            });
            if (nextLevel.length) {
                return context.getChildNode(context, ref, nextLevel);
            }
        },
        getStepNumberByName(stepName) {
            const stepNumbers = Object.keys(this.stepsMap);
            for (const stepNumber of stepNumbers) {
                const step = this.stepsMap[stepNumber];
                if (step && step.content && stepName == step.content.route) {
                    return stepNumber;
                }
            }
        },
    },
    watch: {
        step(newVal, oldVal) {
            if (this.stepsMap[oldVal]) {
                this.stepsMap[oldVal].content.active = false;
            }

            if (this.stepsMap[newVal]) {
                this.stepsMap[newVal].content.active = true;
            }

            this.inputValue = newVal;
        },
        $route: {
            immediate: true,
            handler: function(route) {
                if (!this.step && route.params.stepName) {
                    const stepNumber = this.getStepNumberByName(route.params.stepName);
                    if (stepNumber) {
                        this.step = stepNumber;
                    }
                } else if (route.params.stepName) {
                    const step = this.stepsMap[this.step];
                    if (step && step.content && route.params.stepName != step.content.route) {
                        const stepNumber = this.getStepNumberByName(route.params.stepName);
                        if (stepNumber) {
                            this.step = stepNumber;
                        }
                    }
                } else if (!this.step) {
                    this.step = 1;
                }
            },
        },
    },
};
</script>
